<!--
 * @Author: Ximen
 * @Date: 2021-03-17 14:12:51
 * @LastEditors: Ximen
 * @LastEditTime: 2021-03-25 10:49:43
-->
<template>
  <a-card class="box">
    <p class="title">补充资料</p>
    <img class="blank" src="@/assets/undraw_Post_re_mtr4.png" alt="">
    <a-button type="primary" class="accept-btn" @click="supplementShop()">请补充商城资料</a-button>
    <p class="consulting">任何疑问可咨询400-8808-888</p>
  </a-card>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SupplementaryInformation',
  components: {
  },
  methods: {
    supplementShop() {
      this.$parent.nextStep(2);
    },
  },
});
</script>
<style lang="stylus" scoped>
    .box
      margin 0 auto
      border-radius 20px
      width 420px
      .title
        font-size 24px
        color #073D7D
        margin-bottom 40px
      .blank
        width 220px
        height auto
        margin-bottom 40px
      .accept-btn
        width 100%
        height 50px
        margin-top 10px
        border-radius 5px
        background #3281DD
        margin-bottom 30px
      .consulting
        font-size 14px
        color #000
</style>
